import { Injectable } from '@angular/core';
import { PagedTableStore } from '@/shared/store/base/paged-table-store';
import { UsuarioList, CambiarPasswordPayload } from '../models';
import { USUARIOS_COLUMNS } from './table.columns';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsuariosStore extends PagedTableStore<UsuarioList> {
  override resourcePath = '/api/users';
  override routeBase = 'usuarios';

  override columns = USUARIOS_COLUMNS;

  override canDelete(): boolean {
    return false;
  }

  async changePassword(id: number, payload: CambiarPasswordPayload): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.fullResource}/${id}/password`, payload)
    );
  }
}
